// src/graphql/ai.graphql.ts
import { gql } from '@apollo/client';

export const PROCESS_PRESCRIPTION = gql`
  mutation ProcessPrescription($image: String!) {
    processPrescription(image: $image) {
      success
      parsedData {
        patientName
        mobileNumber
        age
        gender
        doctorName
        date
        tests {
          originalName
          matchedTest {
            TestId
            TestName
            TestCode
            Amount
            categories
          }
          confidence
          recommended
        }
        unmatchedTests
      }
      confidence
      error
      provider
    }
  }
`;

export const SCAN_AND_PROCESS = gql`
  mutation ScanAndProcess($scannerSettings: ScannerInput) {
    scanAndProcess(scannerSettings: $scannerSettings) {
      success
      parsedData {
        patientName
        mobileNumber
        age
        gender
        doctorName
        date
        tests {
          originalName
          matchedTest {
            TestId
            TestName
            TestCode
            Amount
            categories
          }
          confidence
          recommended
        }
        unmatchedTests
        multiPageImages
      }
      pageCount
      provider
    }
  }
`;

// import { gql } from '@apollo/client';
// // In your frontend ai.graphql.ts
// export const PROCESS_PRESCRIPTION = gql`
//   mutation ProcessPrescription($image: String!) {
//     processPrescription(image: $image) {
//       success
//       parsedData {
//         patientName
//         mobileNumber
//         age
//         gender
//         doctorName
//         date
//         tests {
//           name
//           confidence
//         }
//       }
//       confidence
//       error
//     }
//   }
// `;

// // src/graphql/ai.graphql.ts
// import { gql } from '@apollo/client';

// export const PROCESS_PRESCRIPTION = gql`
//   mutation ProcessPrescription($input: PrescriptionInput!) {
//     processPrescription(input: $input) {
//       success
//       parsedData {
//         patientName
//         mobileNumber
//         age
//         gender
//         doctorName
//         date
//         tests {
//           name
//           confidence
//         }
//       }
//       confidence
//       error
//     }
//   }
// `;